import View from './view';
export const LoadableContent = View;
